'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _stripe = require('stripe');

var _stripe2 = _interopRequireDefault(_stripe);

var _querystring = require('querystring');

var _querystring2 = _interopRequireDefault(_querystring);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StripeService = function () {
  function StripeService($q, $http, $window) {
    _classCallCheck(this, StripeService);

    this._stripe = _stripe2.default;
    this._ = { $q: $q, $http: $http, $window: $window };
  }

  _createClass(StripeService, [{
    key: 'setStripeKey',
    value: function setStripeKey(key) {
      this._stripe.setPublishableKey(key);
    }
  }, {
    key: 'token',
    value: function token(number, exp_year, exp_month, cvc) {
      var deferred = this._.$q.defer();

      if (!this.validNumber(number) || !this.validCvc(cvc) || !this.validExpiry(exp_month, exp_year)) {
        deferred.reject('Invalid credit card info');
      } else {
        this._stripe.card.createToken({ number: number, cvc: cvc, exp_month: exp_month, exp_year: exp_year }, function (status, response) {
          if (response.error) {
            deferred.reject(response.error);
          } else {
            deferred.resolve(response.id);
          }
        });
      }

      return deferred.promise;
    }
  }, {
    key: 'validNumber',
    value: function validNumber(num) {
      return this._stripe.card.validateCardNumber(num);
    }
  }, {
    key: 'validExpiry',
    value: function validExpiry(exp_month, exp_year) {
      return this._stripe.card.validateExpiry(exp_month, exp_year);
    }
  }, {
    key: 'validCvc',
    value: function validCvc(cvc) {
      return this._stripe.card.validateCVC(cvc);
    }
  }, {
    key: 'oauthRedirect',
    value: function oauthRedirect(user, feis) {
      var query = _querystring2.default.stringify({
        client_id: STRIPE_CLIENT_ID,
        redirect_uri: IFEIS_APP_URI + '/stripe-callback',
        response_type: 'code',
        scope: 'read_write',
        'stripe_user[email]': user.email,
        'stripe_user[first_name]': user.fname,
        'stripe_user[last_name]': user.lname,
        'stripe_user[business_name]': feis.name,
        state: JSON.stringify({
          id: feis.id,
          slug: feis.slug
        })
      });

      this._.$window.location.href = 'https://connect.stripe.com/oauth/authorize?' + query;
    }
  }, {
    key: 'validateOauthReturn',
    value: function validateOauthReturn(token, feis) {
      return this._.$http.post(IFEIS_API_URI + '/api/auth/validate', {
        token: token,
        feis: feis,
        provider: 'stripe'
      });
    }
  }]);

  return StripeService;
}();

exports.default = angular.module('ifeis.stripe', []).service('fStripe', StripeService).run(function (fStripe) {
  fStripe.setStripeKey(STRIPE_PUBLIC_KEY);
});


//////////////////
// WEBPACK FOOTER
// ./stripe/index.js
// module id = 456
// module chunks = 0